import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyAtuKeEycUUdQCmWsDgEEmVR_nKY2YEqHU',
  appId: '1:827247293530:web:9015365f53e1b4b9f8d463',
  messagingSenderId: '827247293530',
  projectId: 'shiftpal-52a95',
  authDomain: 'shiftpal-52a95.firebaseapp.com',
  storageBucket: 'shiftpal-52a95.firebasestorage.app',
  measurementId: 'G-ZMHEQCTEMD',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);

void setPersistence(auth, browserLocalPersistence);
